import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {Route, Routes, useNavigate, useLocation} from "react-router-dom";
import config from "./config";
import {Box, Text, Anchor, Button, TextInput, InfiniteScroll, ResponsiveContext} from "grommet";
import { LinkPrevious, LinkNext, Home, Document, Search, Download, Close, FormSearch, Clear } from "grommet-icons";
import { ItemFile, ItemFolder } from "./Item";
import PDF from "./PDF";
// import Viewer from "./Viewer";

const Loading = () =>
    <Box flex="grow" justify="center" align="center">Chargement...</Box>;

const SearchBar = ({search, setSearch}) => {

    return (
        <Box className="search" direction="row" round="xsmall" margin="small" border flex={false}>
            {search.length > 0 ? <Button icon={<Close />} onClick={() => setSearch('')} /> : <Button icon={<FormSearch />} />}
            <TextInput plain type="text" value={search}
                       onChange={event => setSearch(event.target.value)} placeholder=""
            />
        </Box>
    )
}

const SearchPath = ({setSearch}) => {
    const size = useContext(ResponsiveContext);
    const navigate = useNavigate();

    return (
        <Box pad="medium" gap="medium" border={{side: 'bottom'}} direction={size === 'small' ? "column" : "row"}>
            <Box direction="row" gap="medium">
                <Box gap="xsmall" direction="row">
                    <Text size="small"><Anchor icon={<Clear size="small" />} onClick={() => setSearch('')} label="Effacer la recherche" /></Text>
                </Box>
            </Box>
        </Box>
    )
}

const Path = ({path, setPath}) => {
    const size = useContext(ResponsiveContext);
    const navigate = useNavigate();

    const goToParent = () => {
        setPath(path.slice(0, -1))
    }

    const goTo = (item) => {
        const idx = path.findIndex(p => p.id === item.id)
        if (idx !== -1) {
            setPath(path.slice(0, idx))
        }
    }

    const goToRoot = () => {
        setPath([])
    }

    return (
        <Box pad="medium" gap="medium" border={{side: 'bottom'}} direction={size === 'small' ? "column" : "row"}>
            <Box direction="row" gap="medium">
                <Box gap="xsmall" direction="row">
                    <Text size="small"><Anchor icon={<Home size="small" />} onClick={goToRoot} label="Accueil" /></Text>
                </Box>
                {path.length > 0 && <Box gap="xsmall" direction="row">
                    <Text size="small"><Anchor icon={<LinkPrevious size="small" />} onClick={goToParent} label="Précédent" /></Text>
                </Box>}
            </Box>
            {path.length > 0 && <Box gap="xsmall" direction={size === 'small' ? "column" : "row"}>
                {
                    path.map((p, i) => {
                        if (path.length === i) {
                            return <Text size="small" key={'p-' + p.id}>/ <Anchor key={p.id} onClick={() => goTo(p)} label={p.name}/></Text>
                        } else {
                            return <Text size="small" key={'p-' + p.id}>/ {p.name}</Text>
                        }
                    })
                }
            </Box>}
        </Box>
    )
}

const Main = () => {
    const [ items, setItems ] = useState([])
    const [ path, setPath ] = useState([])
    const [ show, setShow ] = useState(null)
    const [ search, setSearch ] = useState('')
    const [ loading, setLoading ] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const id = location.pathname.split('/').filter(s => s && s !== 'search')[0];

    let delay = null;

    console.log(path)

    useEffect(() => {
        if (path.length > 0) {
            navigate('/' + path[path.length - 1].id)
        } else {
            navigate('/')
        }
    }, [path])

    useEffect(() => {
        getItems()
    }, [id])

    useEffect(() => {
        clearTimeout(delay);

        if (search.length > 2) {
            delay = setTimeout(() => {

                navigate('/search')

                getItems()

            }, 800);
        } else {
            if (location.pathname === '/search') {
                console.log('clear')
                navigate('/')
                getItems()
            }
        }

    }, [search])

    // useEffect(() => {
    //     getItems()
    // }, [loading])

    const getItems = () => {
        setLoading(true)

        // let url = config.url + '/items' + (path.length > 0 ? '/' + path[path.length - 1].id : '');
        let url = config.url + '/items' + (id ? '/' + id : '');

        if (search.length > 2) {
            url = config.url + '/items?search=' + search;
        }

        axios.get(url)
            .then(({data}) => {
                setItems(Array.isArray(data) ? data : [])
            })
            .finally(() => {
                setLoading(false)
            })
            .catch(error => {
                console.log(error.response)
            });

    }

    const changeDir = (item) => {
        setPath([ ...path, item])
    }

    return (
        <Box>
            <Box flex={false} pad="small">
                <SearchBar search={search} setSearch={setSearch} />

                <Routes>
                    <Route path="/search" element={<SearchPath setSearch={setSearch} />} />
                    <Route path="/:id?" element={<Path path={path} setPath={setPath} />} />
                </Routes>
            </Box>


            <Box pad="small" overflow="auto">
                {loading ? <Loading/> :
                    <InfiniteScroll items={items}>
                        {item => item.isFolder ?
                            <ItemFolder key={item.id} item={item} changeDir={() => changeDir(item)}/> :
                            <ItemFile key={item.id} item={item} onClick={() => setShow(item)}/>}
                    </InfiniteScroll>
                }
            </Box>
            {/*{show && <PDF pdf={show} handleClose={() => setShow(null)} />}*/}
            {/*{show && <Viewer item={show} handleClose={() => setShow(null)} />}*/}
        </Box>

    )
}

export default Main;